module.exports = __webpack_public_path__ + "static/media/1040513700.78b09ee7.jpg";